import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-custom-search-input',
  templateUrl: './custom-search-input.component.html',
  styleUrls: ['./custom-search-input.component.scss'],
  standalone: false
})
export class CustomSearchInputComponent implements OnInit {
  @Input() title: string
  @Input() placeholder: string
  public inputSearch: string

  @Output() eventSearch = new EventEmitter()

  ngOnInit(): void {}

  public onSearch(text: string): void {
    text = text?.trim()
    this.eventSearch.emit(text)
  }
}
